/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_FaqInputs */

const en_svtag_faq = /** @type {(inputs: Svtag_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAQ`)
};

const ar_svtag_faq = /** @type {(inputs: Svtag_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#أسئلة`)
};

const bn_svtag_faq = /** @type {(inputs: Svtag_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAQ`)
};

const de_svtag_faq = /** @type {(inputs: Svtag_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAQ`)
};

const es_svtag_faq = /** @type {(inputs: Svtag_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAQ`)
};

const fr_svtag_faq = /** @type {(inputs: Svtag_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAQ`)
};

const pt_svtag_faq = /** @type {(inputs: Svtag_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAQ`)
};

const zh_svtag_faq = /** @type {(inputs: Svtag_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAQ`)
};

const tr_svtag_faq = /** @type {(inputs: Svtag_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAQ`)
};

const ru_svtag_faq = /** @type {(inputs: Svtag_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAQ`)
};

const pl_svtag_faq = /** @type {(inputs: Svtag_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAQ`)
};

/**
* | output |
* | --- |
* | "#FAQ" |
*
* @param {Svtag_FaqInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_faq = /** @type {((inputs?: Svtag_FaqInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_FaqInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_faq(inputs)
	if (locale === "bn") return bn_svtag_faq(inputs)
	if (locale === "de") return de_svtag_faq(inputs)
	if (locale === "es") return es_svtag_faq(inputs)
	if (locale === "fr") return fr_svtag_faq(inputs)
	if (locale === "pt") return pt_svtag_faq(inputs)
	if (locale === "zh") return zh_svtag_faq(inputs)
	if (locale === "tr") return tr_svtag_faq(inputs)
	if (locale === "ru") return ru_svtag_faq(inputs)
	if (locale === "pl") return pl_svtag_faq(inputs)
	return en_svtag_faq(inputs)
});